export default {
  name: "iconfont",
  props: {
    suffix: {
      type: String,
      default: "joinmc"
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 16
    }
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};